import { render } from "./PanelAvisosEditar.vue?vue&type=template&id=486c17d2"
import script from "./PanelAvisosEditar.vue?vue&type=script&lang=js"
export * from "./PanelAvisosEditar.vue?vue&type=script&lang=js"
script.render = render

export default script